// extracted by mini-css-extract-plugin
module.exports = {"quote":"quote-module--quote--2lt0q"};